import React from 'react';
import { formatValueIfNullOrUndefined } from 'utilities/util';
import { PropertiesRibbonWrapper } from 'components/properties-ribbon';

interface IBookingDetailsTopBarOwnProps {
    documentId: number;
    bookingNumber: string;
    shipmentId: number;
    prepaidCollectIndicator: string;
    originService: string;
    destinationService: string;
    placeOfReceiptCode: string;
    portOfLoadingCode: string;
    portOfDischargeCode: string;
    placeOfDeliveryCode: string;
    isTriTrade: string;
    isActionHidden: boolean;
    incoTerm: string;
}

export const _BookingDetailsTopBar: React.FunctionComponent<IBookingDetailsTopBarOwnProps> = (props) => {
    const propertiesRibbonData = {
        labels: [
            { label: 'Client Booking Number', value: formatValueIfNullOrUndefined(props.bookingNumber), key:`bn-${props.bookingNumber}`  },
            { label: 'Shipment Id', value: formatValueIfNullOrUndefined(props.shipmentId), key:`bn-${props.shipmentId}` },
            { label: 'Collect / Prepaid', value: formatValueIfNullOrUndefined(props.prepaidCollectIndicator), key:`bn-${props.prepaidCollectIndicator}` },
            { label: 'Origin/Destination Service', value: `${formatValueIfNullOrUndefined(props.originService)}/${formatValueIfNullOrUndefined(props.destinationService)}`, key:`bn-${props.originService}` },
            { label: 'Place of Receipt', value: formatValueIfNullOrUndefined(props.placeOfReceiptCode), key:`bn-${props.placeOfReceiptCode}` },
            { label: 'Port of Loading', value: formatValueIfNullOrUndefined(props.portOfLoadingCode), key:`bn-${props.portOfLoadingCode}` },
            { label: 'Port of Discharge', value: formatValueIfNullOrUndefined(props.portOfDischargeCode), key:`bn-${props.portOfDischargeCode}` },
            { label: 'Place of Delivery', value: formatValueIfNullOrUndefined(props.placeOfDeliveryCode), key:`bn-${props.placeOfDeliveryCode}` },
            { label: 'Tri-Trade', value: formatValueIfNullOrUndefined(props.isTriTrade), key:`bn-${props.isTriTrade}` },
            { label: 'Incoterm', value: formatValueIfNullOrUndefined(props.incoTerm), key: `fcr-incoTerm` },
        ],
        actions: [],
        isActionHidden: props.isActionHidden
    }
    return (
        <React.Fragment>
            <PropertiesRibbonWrapper content={propertiesRibbonData} />
        </React.Fragment>
    )
};


export const BookingDetailsTopBar = _BookingDetailsTopBar
